export enum EXAM_RESULT {
  BLOCKED = 'S',
  AVAILABLE = 'N'
}